import { MessageObject, MessageValue } from '@messageformat/react';
import { ContentBlock, MsgDataContent, NestedStrArray } from '../interfaces/ContentBlock';

const parseMsgArrayObject = (obj: MessageObject): NestedStrArray => {
  return Object.values(obj).map((value: MessageValue | MessageObject) => {
    if (typeof value === 'function') {
      return value({}) as string;
    }
    if (typeof value === 'object') {
      return parseMsgArrayObject(value);
    }
    return value.toString();
  });
};

const parseMsgContent = (textContent: MsgDataContent): ContentBlock[] => {
  return Object.keys(textContent).map((k) => {
    return {
      title: textContent[k].title?.(),
      body: parseMsgArrayObject(textContent[k].body),
      image: textContent[k].image?.(),
      width: textContent[k].width(),
      alignLeft: textContent[k].alignLeft?.(),
    };
  });
};

export default parseMsgContent;
